import { PublicProject, PublicProjectSummary } from "@ecologi/shared";
import { trpc } from "../trpc/client";
import { createServerTRPCClient } from "../trpc/server";
import {
  resolvePublicProjectAssetUrls,
  resolvePublicProjectsAssetUrls,
} from "../projects/public-project";

const getProjectClient = () =>
  typeof window === "undefined" ? createServerTRPCClient() : trpc;

export const getAllProjects = async (): Promise<PublicProjectSummary[]> => {
  const projects = await getProjectClient().projects.public.all.query({});

  return resolvePublicProjectsAssetUrls(projects);
};

export const getProjectById = async (
  projectId: number
): Promise<PublicProject> => {
  if (!projectId) {
    throw new Error("Project ID is required");
  }

  const project = await getProjectClient().projects.public.byId.query({
    id: projectId,
  });

  return resolvePublicProjectAssetUrls(project);
};
